import type { RouteObject } from 'react-router';
import { paginaSobDemanda } from '@/app/pagina-sob-demanda';

/**
 * Rotas **públicas** de autenticação: ficam fora da `Shell` (não há menu para quem não entrou) e
 * fora da `RotaProtegida`. Cada uma corresponde a uma rota `@Publico()` do backend.
 *
 * `/convites/:token` entrou na 1.6: a tela é de autenticação (define senha e abre sessão), embora o
 * convite nasça no módulo de usuários. Recuperação (`/recuperar-senha`) e redefinição
 * (`/redefinir-senha/:token`) chegam na 1.9.
 *
 * Todas carregam sob demanda (1.12, `paginaSobDemanda`): quem só vai entrar não baixa a equipe e os
 * papéis, e quem já entrou não baixa de novo a tela de entrada.
 */
export const rotasPublicas: RouteObject[] = [
  {
    path: '/entrar',
    element: paginaSobDemanda(
      () => import('./paginas/PaginaEntrar'),
      (m) => m.PaginaEntrar,
    ),
  },
  {
    path: '/convites/:token',
    element: paginaSobDemanda(
      () => import('./paginas/PaginaAceitarConvite'),
      (m) => m.PaginaAceitarConvite,
      'Abrindo o convite…',
    ),
  },
  // Esqueci minha senha (1.9): públicas porque quem chega aqui não consegue entrar.
  {
    path: '/recuperar-senha',
    element: paginaSobDemanda(
      () => import('./paginas/PaginaRecuperarSenha'),
      (m) => m.PaginaRecuperarSenha,
    ),
  },
  {
    path: '/redefinir-senha/:token',
    element: paginaSobDemanda(
      () => import('./paginas/PaginaRedefinirSenha'),
      (m) => m.PaginaRedefinirSenha,
    ),
  },
];

/** Dentro da `Shell`. Sem `RequerPermissao`: todo autenticado vê o próprio perfil. */
export const rotasProtegidas: RouteObject[] = [
  {
    path: '/perfil',
    element: paginaSobDemanda(
      () => import('./paginas/PaginaPerfil'),
      (m) => m.PaginaPerfil,
      'Abrindo o seu perfil…',
    ),
  },
];

/**
 * Protegidas, mas **fora da Shell** (sem menu): a tela bloqueante da senha nova obrigatória (regra 24,
 * 1.8). Fica num grupo próprio porque `rotasProtegidas` mora dentro da Shell, e a tela bloqueante não pode
 * oferecer menu nem atalho para outra tela.
 */
export const rotasProtegidasSemMenu: RouteObject[] = [
  {
    path: '/trocar-senha',
    element: paginaSobDemanda(
      () => import('./paginas/PaginaTrocarSenhaObrigatoria'),
      (m) => m.PaginaTrocarSenhaObrigatoria,
    ),
  },
];
